import {
  SemanticSearchApi,
  SemanticSearchClient,
} from '@appfolio/backstage-plugin-search-common';
import { createApiRef } from '@backstage/core-plugin-api';
import { SearchQuery, SearchResultSet } from '@backstage/plugin-search-common';
import { SearchApi } from '@backstage/plugin-search-react';

export const semanticSearchApiRef = createApiRef<SemanticSearchApi>({
  id: 'plugin.appfolio-search.service',
});

// techdocs reader page embedded search bar-compatible interface
export class SearchClient extends SemanticSearchClient implements SearchApi {
  public async query(query: SearchQuery) {
    const { filters = {}, term, types = [] } = query;
    if (!term) {
      return { results: [] };
    }
    const results = await this.retrieve({
      text: term,
      filters: [
        ...(types.length
          ? types.map(value => ({
              key: 'type',
              value,
              condition: 'equals' as const,
            }))
          : []),
        ...(Object.keys(filters).length
          ? Object.entries(filters).map(([key, value]) => {
              if (typeof value === 'boolean') {
                return {
                  key,
                  value: Boolean(value),
                  condition: 'equals' as const,
                };
              } else if (typeof value === 'number') {
                return {
                  key,
                  value: Number(value),
                  condition: 'equals' as const,
                };
              }
              return {
                key,
                value: String(value),
                condition: 'equals' as const,
              };
            })
          : []),
      ],
    });
    return {
      results: results.map(({ type, title, text, summary, path }) => ({
        type,
        document: {
          title,
          text: summary ?? text,
          location: path,
        },
      })),
    } satisfies SearchResultSet;
  }
}
